export function getReliabilityScore(user) {
    const completed = user.bookings_count_completed || 0;
    const canceled = user.bookings_count_canceled || 0;
    const toBeConfirmed = user.bookings_count_to_be_confirmed || 0;
    const blacklist = user.count_blacklist || 0;
    const promo = user.count_promo_code || 0;
    const phoneVerified = !!user.phone_verified;
    const emailVerified = !!user.email_verified;

    const totalBookings = completed + canceled + toBeConfirmed;

    // No activity at all: score = 0
    if (totalBookings === 0 && blacklist === 0 && promo === 0) return 0;

    let baseScore = 0;

    if (totalBookings > 0) {
        const completedPerc = completed / totalBookings;
        const canceledPerc = canceled / totalBookings;
        const toBeConfirmedPerc = toBeConfirmed / totalBookings;

        baseScore =
            (completedPerc * 100) -
            (canceledPerc * 40) -
            (toBeConfirmedPerc * 20);
    }

    if (completed === 1 && totalBookings === 1) {
        baseScore = Math.min(baseScore, 80);
    }

    let extras = 0;
    if (promo > 0) extras += 5;
    if (blacklist > 0) extras -= 30;
    if (phoneVerified) extras += 5;
    if (emailVerified) extras += 5;

    let score = baseScore + extras;
    score = Math.max(0, Math.min(score, 100));

    return Math.round(score);
}

export function getReliabilityColor(score, user) {
    const hasNoData =
        (user.bookings_count_completed || 0) === 0 &&
        (user.bookings_count_canceled || 0) === 0 &&
        (user.bookings_count_to_be_confirmed || 0) === 0 &&
        (user.count_blacklist || 0) === 0 &&
        (user.count_promo_code || 0) === 0;

    if (hasNoData) return 'grey';
    if (score >= 75) return 'green';
    if (score >= 35) return 'orange';
    return 'red';
}
